import * as React from "react"
import type { SVGProps } from "react"
const SvgArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M13 8.1v11.2a1 1 0 0 1-.28.7 1 1 0 0 1-.71.3 1 1 0 0 1-.72-.3 1 1 0 0 1-.28-.7V8.1L6.1 13q-.3.3-.7.29a1 1 0 0 1-.7-.32q-.28-.3-.29-.7a1 1 0 0 1 .29-.7l6.6-6.6q.14-.15.32-.21T12 4.7t.37.06a1 1 0 0 1 .33.21l6.6 6.6a1 1 0 0 1 .27.7q0 .4-.28.7-.3.3-.7.3a1 1 0 0 1-.72-.3z" />
  </svg>
)
export default SvgArrowUp
